import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
  Box,
} from '@mui/material';
import NewTable from '../NewTable';

const RobotTable = (props) => {
  const {
    title,
    name,
    selectable,
    headerItems,
    contentItems,
    lengthOptions,
    loading,
    sort,
    total,
    rowsPerPage,
    page,
    order,
    selected,
    onItemUpdateClick,
    handleAllClick,
    handleCheckClick,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSortClick,
  } = props;

  return (
    <Card sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 2,
          mx: 2,
        }}
      >
        <Typography variant="h5">{title}</Typography>
        <CardActions>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            disabled={selected.length === 0}
            onClick={onItemUpdateClick}
          >
            선택 수정
          </Button>
        </CardActions>
      </Box>
      <CardContent>
        {!loading &&
          contentItems.length === 0 &&
          name === 'robot_status' &&
          '등록된 로봇이 없습니다.'}
        {!loading &&
          contentItems.length === 0 &&
          name === 'subUser_status' &&
          '등록된 사용자가 없습니다.'}
        {contentItems.length > 0 && (
          <NewTable
            {...{
              selectable,
              headerItems,
              contentItems,
              lengthOptions,
              total,
              rowsPerPage,
              page,
              selected,
              handleAllClick,
              handleCheckClick,
              handleChangePage,
              handleChangeRowsPerPage,
              handleSortClick,
              order,
              orderBy: sort,
            }}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default RobotTable;
